import React from 'react';
import { systemRoleLabel, coveragePct } from '../utils/rbacLabels';
import { IITH } from '@/pages/landing/iithBrand';

/** Role picker sidebar with permission coverage bars. */
export default function PermissionsRoleList({
  roles, selected, checkedCount, permissionTotal, onSelect,
}) {
  return (
    <aside
      className="rounded-xl border bg-white shadow-sm flex flex-col max-h-[72vh] overflow-hidden"
      data-testid="permissions-role-list"
    >
      <div className="px-4 py-3 border-b bg-zinc-50/80">
        <p className="text-sm font-semibold text-zinc-900">Clinic roles</p>
        <p className="text-[11px] text-zinc-500 mt-0.5">
          Select a role to edit what it can do. Users inherit these on next login / refresh.
        </p>
      </div>
      <div className="overflow-y-auto p-2 space-y-1 flex-1">
        {roles.map((r) => {
          const isSel = selected === r.role_key;
          const count = isSel ? checkedCount : (r.permission_codes || []).length;
          const pct = coveragePct(count, permissionTotal || 1);
          return (
            <button
              key={r.role_key}
              type="button"
              onClick={() => onSelect(r.role_key)}
              className={`w-full text-left px-3 py-2.5 rounded-lg text-sm transition border ${
                isSel
                  ? 'border-transparent text-white shadow-sm'
                  : 'border-transparent hover:bg-zinc-50 text-zinc-700'
              }`}
              style={isSel ? { background: IITH.navy } : undefined}
              data-testid={`perm-role-${r.role_key}`}
            >
              <div className="font-medium flex items-center justify-between gap-2">
                <span className="truncate">{r.name}</span>
                <span className={`text-[10px] tabular-nums shrink-0 ${isSel ? 'text-white/70' : 'text-zinc-400'}`}>
                  {count}
                </span>
              </div>
              <p className={`text-[11px] mt-0.5 truncate ${isSel ? 'text-white/55' : 'text-zinc-500'}`}>
                {systemRoleLabel(r.system_role)}
              </p>
              <div className={`mt-2 h-1 rounded-full overflow-hidden ${isSel ? 'bg-white/20' : 'bg-zinc-100'}`}>
                <div
                  className="h-full rounded-full"
                  style={{
                    width: `${pct}%`,
                    background: isSel ? IITH.saffron : IITH.navy,
                  }}
                />
              </div>
            </button>
          );
        })}
      </div>
    </aside>
  );
}
